import React from 'react';
import parser from 'react-html-parser';

import classes from './ExhibitionItem.module.scss';

const ExhibitionItem = props => {
    return <div className={classes.ExhibitionItem}>
        <h3>{props.title}</h3>
        {parser(props.content)}
    </div>
}

export default ExhibitionItem;